// hmc_theme_2026.js
// 2026 현대차·기아 공급망 ESG 테마 평가 결과보고서 정적 데이터 (KO).
//   - rubric: 지표(W-1..W-14 / BD-1..BD-13)별 분류·주제·질문·배점 + 경영수준별 답변/도출리스크/개선과제
//   - levelMeta: 경영 수준 → 관리 상태 라벨/설명 (미흡/보통/우수/매우우수)
//   - appendixUrls: 참고 URL 3개 그룹
//   - riskSummary: 보유 리스크 요약 (정적 placeholder — 추후 기본문항 기반 동적 산정 예정)
//   EN/CN 은 추후 추가. 현재 KO 전용.

export const rubric = {
    water: {
        name: '수자원',
        order: [
            'W-1',
            'W-2',
            'W-3',
            'W-4',
            'W-5',
            'W-6',
            'W-7',
            'W-8',
            'W-9',
            'W-10',
            'W-11',
            'W-12',
            'W-13',
            'W-14'
        ],
        indicators: {
            'W-1': {
                code: 'W-1',
                sub_code: 'TH1.1',
                topic: '명문화된 수자원 관리 정책',
                category: '정책 및 거버넌스',
                question: '수자원 보호 원칙을 담은 정책(독립 문서 또는 환경방침 내 조항)을 보유하고 있습니까?',
                cap: 8,
                levels: {
                    insufficient: {
                        answer: '아니오, 보유하고 있지 않습니다.',
                        risk: '수자원 보호 원칙이 전혀 없어 규제 위반·환경사고 시 법적 제재 및 이미지 손상 위험이 매우 높음',
                        task: '① 환경경영방침에 수자원 보호 원칙 우선 반영 \n② 독립 수자원 정책 수립 일정 로드맵 마련'
                    },
                    average: {
                        answer: '예, 환경경영방침 내 수자원 보호 및 관리 원칙을 명시하고 있습니다.',
                        risk: '독립 수자원 정책 부재로 규제 강화 시 대응이 느릴 수 있으며, 고객·투자자 요구 수준에 미달할 위험',
                        task: '① 환경방침 내 수자원 조항 이행 현황 점검\n② 독립 정책 수립 필요성 및 우선순위 검토'
                    },
                    excellent: {
                        answer: '예, 독립적인 수자원 관리 정책을 보유하고 있습니다.',
                        risk: '정기 검토 체계 및 외부 공개 미비로 이해관계자 신뢰도 및 ESG 투명성 개선 여지 존재',
                        task: '① 수자원 정책의 경영진 승인 절차 공식화\n② 정기 검토 주기 및 외부 공개 채널 설정'
                    },
                    outstanding: {
                        answer: '예,  독립적인 수자원 관리 정책을 보유하고 있으며, 정기 검토 체계를 갖추고 경영진 승인, 외부 이해관계자가 접근 가능한 채널에 공개하고 있습니다.',
                        risk: '현재 최고 수준이나, 정책의 실효성과 현장 이행률을 지속 점검하여 형식적 관리에 그치지 않도록 유지 필요',
                        task: '[추가 개선 제안]\n① 수자원 정책 이행 현황 정기 감사 및 개선 사이클 운영\n② 이해관계자 피드백을 반영한 다음 연도 정책 갱신'
                    }
                }
            },
            'W-2': {
                code: 'W-2',
                sub_code: 'TH1.2',
                topic: '이사회 및 경영진 보고 체계',
                category: '정책 및 거버넌스',
                question: '수자원 관련 리스크·기회가 이사회·경영진에게 정기 보고되어 의사결정에 반영됩니까?',
                cap: 7,
                levels: {
                    insufficient: {
                        answer: '아니오, 이사회·경영진에 대한 수자원 보고 체계가 없습니다.',
                        risk: '수자원 관련 중대 사고 발생 시 경영진이 적시에 인지·대응하지 못해 피해 확대 및 법적·재무적 책임 위험',
                        task: '① 수자원 관련 주요 리스크 항목 목록화\n② 경영진 보고를 위한 최소한의 보고 양식 및 주기 설계'
                    },
                    average: {
                        answer: '예, 수자원 관리 활동 성과를 담당 임원에게 비정기적으로 보고하고 있습니다.',
                        risk: '보고 주기가 불규칙하여 사안 발생 시 경영진 대응이 지연될 수 있으며, 의사결정 반영 여부를 추적하기 어려움',
                        task: '① 수자원 보고 주기 및 형식 표준화\n② 경영진 피드백 및 결정 사항 기록 체계 구축'
                    },
                    excellent: {
                        answer: '예, 수자원 리스크·기회를 경영진에게 정기적으로 보고하고 의사결정에 활용하고 있습니다.',
                        risk: '이사회 수준 보고 및 공개 체계가 미비하여 ESG 평가 항목 일부 미충족 가능성 존재',
                        task: '① 이사회·위원회 수준으로 보고 체계 격상 검토\n② 보고 이력 문서화 및 공개 가능 여부 검토'
                    },
                    outstanding: {
                        answer: '예, 이사회 또는 위원회에 수자원 리스크·기회가 정기 보고되며, 보고 이력과 결정 사항을 문서화하여 공개하고 있습니다.',
                        risk: '현행 체계를 유지하며, 보고 내용의 품질·정확성 및 이해관계자와의 소통 실효성을 지속 점검 필요',
                        task: '[추가 개선 제안]\n① 이사회 보고 내용의 정량적 근거 강화\n② 이해관계자 공개 보고 항목 확대 및 국제 기준 연계'
                    }
                }
            },
            'W-3': {
                code: 'W-3',
                sub_code: 'TH1.3',
                topic: '전사적 정량 목표 설정',
                category: '정책 및 거버넌스',
                question: '용수 절감 및 재이용률에 대해 기한이 명시된(Time-bound) 구체적 목표를 보유하고 있습니까?',
                cap: 8,
                levels: {
                    insufficient: {
                        answer: '아니오, 수자원 관련 정량적 목표가 없습니다.',
                        risk: '성과 측정·개선 방향 부재로 용수 과다 사용 지속. 환경부하 증가 및 ESG 평가 최하위 등급 위험',
                        task: '① 현재 취수량·재이용률 베이스라인 데이터 확보\n② 단기(1년) 우선 목표 수치 설정 착수'
                    },
                    average: {
                        answer: '예, 내부 관리용 용수 절감 목표(기한 미명시)를 보유하고 있습니다.',
                        risk: '기한 미명시 목표는 ESG 평가에서 낮은 점수를 받으며, 실질적 감축 성과로 이어지지 않을 위험',
                        task: '① 기존 목표에 달성 기한 및 베이스라인 수치 추가\n② 연간 진척 현황 관리 체계 수립'
                    },
                    excellent: {
                        answer: '예, 구체적인 기한(단·중·장기)이 명시된 용수 절감 또는 재이용률 목표를 수립하고 진척을 관리하고 있습니다.',
                        risk: '과학 기반(SBT) 또는 국제 기준과의 연계 및 외부 공시가 이루어지지 않아 글로벌 ESG 평가 상위권 진입에 한계',
                        task: '① SBTi Water 등 국제 기준 연계 가능성 검토\n② 목표 및 달성 현황 외부 공시 계획 수립'
                    },
                    outstanding: {
                        answer: '예, 과학 기반(SBT) 또는 국제 기준에 연계된 기한 명시 목표를 수립하고 외부에 공시하고 있습니다.',
                        risk: '현 수준 유지와 함께, 목표 달성 여부의 제3자 검증 및 미달 시 수정 계획 수립 프로세스 보완 필요',
                        task: '[추가 개선 제안]\n① 목표 달성 현황 제3자 검증 도입 검토\n② 미달 시 원인 분석 및 목표 재설정 프로세스 공식화'
                    }
                }
            },
            'W-4': {
                code: 'W-4',
                sub_code: 'TH1.4',
                topic: '수자원 리스크 식별',
                category: '리스크 분석 및 평가',
                question: '용수 부족이나 홍수 등의 물리적 리스크와 규제 강화나 요금 인상 등의 전환 리스크를 포괄하여 수자원 리스크를 분석하고 있습니까?',
                cap: 7,
                levels: {
                    insufficient: {
                        answer: '아니오, 수자원 리스크를 분석하고 있지 않습니다.',
                        risk: '용수 공급 중단·규제 위반 등 사고 발생 시 사전 대비 없이 피해가 확대될 수 있으며, ESG 평가 시 리스크 관리 항목 감점 위험',
                        task: '① 물리적·전환 리스크 구분 목록화\n② WRI Aqueduct 등 공인 도구 활용 초기 스크리닝 실시'
                    },
                    average: {
                        answer: '예, 주요 물리적 리스크(예: 공급 중단)는 인지하고 있으나 체계적 분석 방법론은 없습니다.',
                        risk: '전환 리스크(규제·요금) 누락으로 정책 변화에 취약하며, 리스크 관리의 재현성과 일관성이 낮음',
                        task: '① 물리적·전환 리스크 분류 체계 도입\n② 기존 인지 리스크를 공식 리스크 목록으로 문서화'
                    },
                    excellent: {
                        answer: '예, 물리적 리스크와 전환 리스크를 구분하여 분석하고 내부 리스크 관리 체계에 반영하고 있습니다.',
                        risk: '정량적 분석 및 외부 공시 미비로 투자자·고객의 리스크 관리 수준 검증 요구에 대응하기 어려움',
                        task: '① 리스크 정량화(발생 가능성·영향도) 시도\n② 분석 결과의 외부 보고서 수록 검토'
                    },
                    outstanding: {
                        answer: '예, 공식적 방법론(TCFD, WRI Aqueduct 등)을 활용해 정량화하고 외부에 공시하고 있습니다.',
                        risk: '분석 방법론과 결과의 신뢰성 유지를 위해 정기 업데이트 및 제3자 검증 체계 보완 필요',
                        task: '[추가 개선 제안]\n① 리스크 분석 결과의 정기 갱신 주기 및 담당자 지정\n② 외부 감사 또는 검증 프로세스 도입 검토'
                    }
                }
            },
            'W-5': {
                code: 'W-5',
                sub_code: 'TH1.5',
                topic: '수자원 지역 리스크 파악',
                category: '리스크 분석 및 평가',
                question: '사업장이 물 부족 위험 지역(water-stressed area)에 위치해 있는지 파악하고 있습니까?',
                cap: 7,
                levels: {
                    insufficient: {
                        answer: '아니오, 사업장의 물 부족 위험 지역 해당 여부를 파악하고 있지 않습니다.',
                        risk: '물 부족 지역 사업장에서 예고 없이 용수 공급이 중단되거나 조업이 차질을 빚을 수 있으며, 규제 대응 우선순위 설정 불가 위험',
                        task: '① WRI Aqueduct 활용 전 사업장 물 부족 위험 지역 수준 스크리닝\n② 고위험 지역 사업장 우선 관리 목록 작성'
                    },
                    average: {
                        answer: '예, 일부 사업장에 대해 물 부족 지역 해당 여부를 비공식적으로 파악하고 있습니다.',
                        risk: '전 사업장 대상 체계적 분석 미비로 고위험 지역 사업장 누락 가능성이 있으며, 우선순위 기반 대응이 어려움',
                        task: '① 전 사업장 대상 WRI Aqueduct 스크리닝 적용\n② 결과를 바탕으로 고위험 사업장 우선 관리 목록 작성'
                    },
                    excellent: {
                        answer: '예, 전체 사업장에 대해 공인 도구를 활용하여 물 부족 위험 지역 여부를 파악하고 있습니다.',
                        risk: '정기 업데이트 및 외부 공시 미비로 기후 변화에 따른 지역 리스크 변화를 반영하지 못할 위험',
                        task: '① 물 부족 위험 지역 분석 정기 갱신 주기 설정(연 1회 이상)\n② 분석 결과를 지속가능경영보고서에 수록 검토'
                    },
                    outstanding: {
                        answer: '예, 전체 사업장의 물 부족 현황을 정기적으로 업데이트하고 외부에 공시하며, 고위험 지역 대응 계획과 연동하고 있습니다.',
                        risk: '현행 수준을 유지하며 기후 변화 시나리오 반영, 지역 사회와의 물 공유 협력 등으로 체계 고도화 필요',
                        task: '[추가 개선 제안]\n① 기후 시나리오별 물 부족 위험 전망 분석 도입\n② 지역 사회·유관기관과의 협력 프로그램 연계'
                    }
                }
            },
            'W-6': {
                code: 'W-6',
                sub_code: 'TH1.6',
                topic: '수원별 취수량 세분화',
                category: '현황 측정 및 모니터링',
                question: '지표수·지하수·해수 등 취수원별 사용량을 구분하여 기록하고 있습니까? 해당 답변을 선택하고 사용량을 입력하여 주십시오.',
                cap: 7,
                levels: {
                    insufficient: {
                        answer: '아니오, 취수원별 사용량을 구분하여 기록하지 않습니다.',
                        risk: '특정 수원(지하수 등) 과의존 위험을 인지하지 못해 공급 중단 리스크에 무방비이며, GRI·CDP 공시 기준 미달 위험',
                        task: '① 사업장별 주요 수원 현황 파악 및 목록화\n② 수원별 취수량 측정 계획 수립 및 계량기 설치 검토'
                    },
                    average: {
                        answer: '예, 일부 수원의 취수량만 기록하며, 지하수·지표수 등은 구분 관리되지 않습니다.',
                        risk: '지하수·지표수 등 누락 수원에서의 과취수 리스크가 잠재하며, GRI·CDP 요구 수준의 부분 미달',
                        task: '① 미측정 수원 파악 및 측정 계획 수립\n② 전 수원 통합 데이터 관리 체계 구축'
                    },
                    excellent: {
                        answer: '예, 공공수도·지표수·지하수  등 주요 수원별로 취수량을 측정·기록하고 연간 집계합니다.',
                        risk: '사업장별 집계 및 외부 공시, 제3자 검증이 이루어지지 않아 글로벌 공시 기준 완전 충족에는 미달',
                        task: '① 수원별 데이터를 사업장 단위로 세분화\n② 외부 보고서 수록 및 검증 계획 수립'
                    },
                    outstanding: {
                        answer: '예, 수원별 취수량을 사업장별로 집계하고 외부에 공시하며, 제3자 검증을 받고 있습니다.',
                        risk: '현행 수준 유지와 함께, 취수 효율성 지표(원단위 등) 도입 및 감축 목표와의 연동 고도화 필요',
                        task: '[추가 개선 제안]\n① 취수 원단위(생산량 대비) 지표 산출 및 추세 관리\n② 감축 목표 달성 현황과 취수 데이터 연계 보고'
                    }
                }
            },
            'W-7': {
                code: 'W-7',
                sub_code: 'TH1.7',
                topic: '배출처별 방류량 세분화',
                category: '현황 측정 및 모니터링',
                question: '폐수가 어디로(하천·지하·하수처리장 등) 배출되는지 배출처를 구분하여 방류량을 기록하고 있습니까?',
                cap: 7,
                levels: {
                    insufficient: {
                        answer: '아니오, 배출처를 구분하여 방류량을 기록하지 않습니다.',
                        risk: '수계 오염 발생 시 오염 경로 추적이 불가하여 법적 책임 부담이 증가하고, GRI 303-4 미준수로 인한 공시 리스크 발생',
                        task: '① 현재 폐수 배출 경로 및 배출처 목록 작성\n② 배출처별 방류량 측정 및 기록 체계 구축'
                    },
                    average: {
                        answer: '예, 주요 배출처는 파악하고 있으나 전체 배출처별 데이터는 없습니다.',
                        risk: '누락 배출처에서의 오염 위험이 잠재하며, 규제 감사 시 데이터 공백으로 인한 불이익 가능성',
                        task: '① 미파악 배출처 현황 조사 및 목록 완성\n② 전 배출처 방류량 측정 계획 수립'
                    },
                    excellent: {
                        answer: '예, 하천·지하·하수처리장 등 배출처별 폐수량을 측정·기록하고 연간 집계합니다.',
                        risk: '외부 공시 및 수질 범주별 구분 보고가 이루어지지 않아 GRI 303-4 완전 준수에는 미달',
                        task: '① 담수/기타 수질 범주 구분 체계 도입\n② 배출처별 데이터 외부 보고서 수록 계획 수립'
                    },
                    outstanding: {
                        answer: '예, 배출처별 폐수량을 외부에 공시하고 담수/기타 수질 범주로 구분하여 보고합니다.',
                        risk: '현행 수준을 유지하며, 배출 수질 기준 초과 리스크 모니터링 및 방류 감축 목표와의 연계 강화 필요',
                        task: '[추가 개선 제안]\n① 방류 수질 기준 초과 위험 지표 설정 및 주기적 모니터링\n② 방류량 감축 목표 수립 및 성과 추적'
                    }
                }
            },
            'W-8': {
                code: 'W-8',
                sub_code: 'TH1.8',
                topic: '물리적 수자원 리스크 파악 및 대비',
                category: '대응 및 실행 전략',
                question: '기후변화로 인한 수자원 위험이 사업장에 미치는 영향을 파악하고, 이에 대한 중장기적인 대비책을 마련하고 있습니까?',
                cap: 7,
                levels: {
                    insufficient: {
                        answer: '아니오, 기후변화로 인한 수자원 위험의 영향을 파악하고 있지 않습니다.',
                        risk: '수자원 위험 인식 부재로 인해 기후 이상 현상 발생 시 생산 차질·시설 피해·공급망 붕괴 등 복합 피해에 무방비로 노출될 위험',
                        task: '① 사업장 소재 지역의 홍수·가뭄 발생 가능성 및 과거 이력 조사\n② 수자원 위험이 생산·운영에 미치는 영향 초기 검토 및 내부 공유'
                    },
                    average: {
                        answer: '예, 기후변화로 인한 수자원 위험이 사업장에 영향을 줄 수 있음을 인식하고 있으나, 체계적인 대비 방안은 아직 마련되지 않았습니다.',
                        risk: '체계적인 대비 방안 부재로 수자원 위험이 현실화될 경우 즉각 대응이 어려워 피해 규모와 복구 기간이 크게 늘어날 위험',
                        task: '① 사업장별 중장기 수자원 위험(홍수·가뭄) 영향 분석 수행\n② 용수 공급 중단 상황을 고려한 생산 유지 방안 및 대체 수원 확보 계획 수립'
                    },
                    excellent: {
                        answer: '예, 기후변화로 인한 수자원 위험이 사업장에 미치는 영향을 분석하고, 시나리오에 기반한 중장기 대비 계획을 수립하고 있습니다.',
                        risk: '수립된 대비 계획의 실효성 검증(모의 점검 등)과 투자자·고객 대상 외부 공시가 이루어지지 않아 리스크 관리 수준에 대한 외부 신뢰도 확보에 한계',
                        task: '① 수자원 위험 대비 계획에 대한 정기 검토 및 모의 점검 실시(연 1회 이상)\n② TCFD 프레임워크에 따른 기후 리스크 대응 현황 외부 공시'
                    },
                    outstanding: {
                        answer: '예, 기후변화로 인한 수자원 위험이 사업장에 미치는 영향을 분석하고, 시나리오 기반 중장기 대비 계획을 수립하고 정기적으로 점검하며, TCFD 프레임워크에 따라 외부에 공시하고 있습니다.',
                        risk: '현행 수준을 유지하면서 기후변화 시나리오 정기 갱신 및 공급망 연계 대비 체계 고도화 필요',
                        task: '[추가 개선 제안]\n① 기후변화 시나리오 정기 갱신(IPCC 최신 보고서 반영)\n② 주요 협력사와 연계한 수자원 위험 공동 대응 체계 구축'
                    }
                }
            },
            'W-9': {
                code: 'W-9',
                sub_code: 'TH1.9',
                topic: '위기 대응 매뉴얼(SOP)',
                category: '대응 및 실행 전략',
                question: '수질 사고나 공급 중단 시 즉각 대응할 수 있는 절차를 보유하고 훈련을 시행합니까?',
                cap: 7,
                levels: {
                    insufficient: {
                        answer: '아니오, 수자원 관련 위기 대응 절차가 없습니다.',
                        risk: '돌발 사고 발생 시 대응 지연으로 생산 손실·환경 피해·규제 제재가 복합적으로 발생할 위험이 매우 높음',
                        task: '① 수질 사고·공급 중단 시나리오별 대응 절차 초안 작성\n② 담당자 역할과 연락 체계 명문화'
                    },
                    average: {
                        answer: '예, 비공식적인 대응 지침이 있으나 문서화되지 않았습니다.',
                        risk: '문서화 미비로 사고 발생 시 대응 일관성이 없고, 재발 방지 체계 수립이 어려우며 법적 책임 증가',
                        task: '① 기존 비공식 지침을 SOP 형태로 문서화\n② 연 1회 이상 모의 훈련 시행 및 결과 기록'
                    },
                    excellent: {
                        answer: '예, 문서화된 위기 대응 매뉴얼(SOP)을 보유하고 정기적으로 훈련을 시행합니다.',
                        risk: '훈련 결과 기반 SOP 개선 및 경영진 보고·외부 감사가 이루어지지 않아 제도적 완결성이 부족',
                        task: '① 훈련 결과를 반영한 SOP 정기 개정 프로세스 수립\n② 훈련 결과 경영진 보고 체계 구축'
                    },
                    outstanding: {
                        answer: '예, SOP를 보유하고 정기 훈련·사후 검토를 시행하며, 결과를 경영진에게 보고하고 외부 감사를 받습니다.',
                        risk: '현행 체계 유지와 함께, 타 기업·기관과의 협력 대응 체계 및 지역 사회 알림 프로세스 고도화 필요',
                        task: '[추가 개선 제안]\n① 외부 기관(지자체·소방서 등)과의 협력 대응 MOU 검토\n② 이해관계자 통보 절차 및 커뮤니케이션 채널 정비'
                    }
                }
            },
            'W-10': {
                code: 'W-10',
                sub_code: 'TH1.10',
                topic: '고위험 지역 감축 계획',
                category: '대응 및 실행 전략',
                question: '물 부족 위험(물 스트레스)이 높은 지역의 사업장을 대상으로 별도의 용수 감축 로드맵을 수립했습니까?',
                cap: 7,
                levels: {
                    insufficient: {
                        answer: '아니오, 물 부족 위험 지역 사업장에 대한 별도 감축 계획이 없습니다.',
                        risk: '지역 물 부족 심화 시 취수 허가 제한, 지역 사회 분쟁, 생산 중단 위험이 집중될 수 있으며 규제 대응 능력도 부재',
                        task: '① 물 부족 위험 지역 사업장 우선 리스트업\n② 해당 사업장 대상 연간 용수 감축 목표 수치 설정 착수'
                    },
                    average: {
                        answer: '예, 물 부족 위험 지역 사업장을 인지하고 있으나 별도 감축 목표는 수립하지 않았습니다.',
                        risk: '고위험 사업장의 용수 사용량이 방치되어 지역 물 분쟁이나 취수 허가 제한 리스크가 상존',
                        task: '① 물 부족 고위험 사업장 용수 사용 현황 데이터 확보\n② 기한 명시 감축 목표 수치 설정 착수'
                    },
                    excellent: {
                        answer: '예, 물 부족 위험 지역 사업장을 대상으로 기한이 명시된 용수 감축 목표와 로드맵을 수립하고 있습니다.',
                        risk: '지역 사회 협력 및 외부 공시가 이루어지지 않아 이해관계자 신뢰도 및 ESG 평가 항목 일부 미충족',
                        task: '① 감축 로드맵 진척 현황 외부 보고서 수록\n② 지역 수자원 유관기관과의 소통 채널 구축'
                    },
                    outstanding: {
                        answer: '예, 지역 사업장을 대상으로 물 부족 위험 지역별 맞춤 감축 로드맵을 수립하고, 성과를 외부에 공시하고 있습니다.',
                        risk: '현행 수준 유지와 함께, 지역 생태계 복원 기여 및 물 분쟁 예방을 위한 지역 사회 협약 체결 고도화 필요',
                        task: '[추가 개선 제안]\n① 지역 사회 물 공유 협약(Water Stewardship) 체결 검토\n② 지역 생태계 복원 기여 지표 설정 및 보고'
                    }
                }
            },
            'W-11': {
                code: 'W-11',
                sub_code: 'TH1.11',
                topic: '용수 재이용 최적화',
                category: '대응 및 실행 전략',
                question: '생산 공정에서 발생하는 물을 다시 사용(재이용·재활용)하기 위한 설비나 절차를 운영하고 있습니까?',
                cap: 7,
                levels: {
                    insufficient: {
                        answer: '아니오, 용수 재이용 설비나 절차가 없습니다.',
                        risk: '신규 취수량이 과도하게 증가하고 폐수 처리 비용도 상승하며, 용수 재이용 관련 ESG 평가 및 고객 요구에 대응 불가 위험',
                        task: '① 현재 공정별 용수 흐름 파악 및 재이용 가능 지점 진단\n② 소규모 재이용 시범 설비 또는 절차 도입 검토'
                    },
                    average: {
                        answer: '예, 일부 공정에서 비공식적으로 용수를 재활용하고 있으나 체계적 관리가 이루어지지 않습니다.',
                        risk: '재이용량 미측정으로 성과 관리와 개선이 불가하며, CDP·GRI 공시 항목 충족 불가',
                        task: '① 비공식 재활용 공정의 용수 흐름 파악 및 측정 체계 도입\n② 재이용량 데이터 기록 및 집계 체계 구축'
                    },
                    excellent: {
                        answer: '예, 재이용 설비 또는 공식 절차를 운영하고 재이용량을 측정·기록하고 있습니다.',
                        risk: '재이용률 외부 공시 및 지속 개선 목표 연계가 미비하여 이해관계자 신뢰도 제고에 한계',
                        task: '① 재이용률(재이용량/취수량) 지표 산출 및 추세 관리\n② 외부 보고서 수록 및 개선 목표와 연동'
                    },
                    outstanding: {
                        answer: '예, 재이용·순환 시스템을 체계적으로 운영하고 재이용률을 외부에 공시하며 지속 개선 목표를 설정하고 있습니다.',
                        risk: '현행 수준 유지와 함께, 제로 액체 배출(ZLD) 등 고도화 기술 도입 가능성 및 재이용수 수질 관리 체계 점검 필요',
                        task: '[추가 개선 제안]\n① ZLD 등 고도화 재이용 기술 타당성 검토\n② 재이용수 수질 기준 수립 및 정기 모니터링 체계 구축'
                    }
                }
            },
            'W-12': {
                code: 'W-12',
                sub_code: 'TH1.12',
                topic: '공급망 수자원 관리',
                category: '공급망 관리 및 공시',
                question: '협력사(원재료 공급업체 포함)의 수자원 관련 리스크를 파악하고 있습니까?',
                cap: 7,
                levels: {
                    insufficient: {
                        answer: '아니오, 협력사의 수자원 리스크를 파악하고 있지 않습니다.',
                        risk: '공급망 내 수자원 오염 또는 부족 발생 시 원재료 수급 중단과 납기 지연이 발생하며, 고객사 공급망 실사 대응 실패 위험',
                        task: '① 매출 영향 상위 협력사 목록화 및 용수 사용 현황 초기 파악\n② 협력사 수자원 관리 기준 마련 및 설문 조사 착수'
                    },
                    average: {
                        answer: '예, 일부 주요 협력사의 수자원 관련 리스크를 비공식적으로 파악하고 있습니다.',
                        risk: '비공식 파악으로 데이터 신뢰도가 낮으며, 고위험 협력사 누락 가능성이 있어 공급망 전체 리스크 관리에 한계',
                        task: '① 비공식 파악 내용의 공식 문서화 및 협력사 리스크 목록 작성\n② 수자원 관련 협력사 평가 기준 초안 마련'
                    },
                    excellent: {
                        answer: '예, 주요 협력사를 대상으로 수자원 사용 현황 및 리스크를 체계적으로 파악하고 개선을 권고하고 있습니다.',
                        risk: '전체 공급망 대상 평가 및 개선 성과 외부 공시가 이루어지지 않아 글로벌 고객사 요구 수준에 미달 가능',
                        task: '① 수자원 리스크 평가 대상을 전 협력사로 단계적 확대\n② 협력사 개선 성과를 외부 보고서에 수록'
                    },
                    outstanding: {
                        answer: '예, 전체 공급망 대상 수자원 리스크 평가를 시행하고, 고위험 협력사와 협력하여 개선 성과를 외부에 공시하고 있습니다.',
                        risk: '현행 수준 유지와 함께, 협력사 수자원 관리 역량 강화 지원 프로그램 및 공동 감축 목표 설정 고도화 필요',
                        task: '[추가 개선 제안]\n① 협력사 수자원 역량 강화 교육·지원 프로그램 운영\n② 공급망 공동 감축 목표 및 인센티브 체계 검토'
                    }
                }
            },
            'W-13': {
                code: 'W-13',
                sub_code: 'TH1.13',
                topic: '협력사 수자원 데이터 수집 및 검증',
                category: '공급망 관리 및 공시',
                question: '협력사로부터 용수 사용량 데이터를 수집하고 검증하고 있습니까?',
                cap: 7,
                levels: {
                    insufficient: {
                        answer: '아니오, 협력사로부터 용수 사용량 데이터를 수집하고 있지 않습니다.',
                        risk: '공급망 수자원 공시 불가로 ESG 평가 등급 하락 및 글로벌 고객사 실사 대응 실패 위험',
                        task: '① 주요 협력사 대상 용수 사용량 데이터 수집 양식 개발\n② ESG팀 또는 구매팀 내 담당자 지정 및 수집 프로세스 수립'
                    },
                    average: {
                        answer: '예, 일부 주요 협력사로부터 용수 사용량 데이터를 비정기적으로 수집하고 있습니다.',
                        risk: '비정기 수집으로 데이터 누락이 빈번하며, 검증 절차 부재로 공시 데이터 신뢰성 확보 곤란',
                        task: '① 정기 데이터 수집 주기(반기/연간) 및 제출 양식 표준화\n② 수집 데이터 내부 검토 및 이상치 확인 절차 마련'
                    },
                    excellent: {
                        answer: '예, 주요 협력사를 대상으로 용수 사용량 데이터를 정기적으로 수집하고 내부 검토를 실시하고 있습니다.',
                        risk: '전체 공급망 대상 수집 미완료 및 제3자 검증 부재로 공시 데이터의 외부 신뢰도 확보 한계',
                        task: '① 데이터 수집 대상을 전 협력사로 단계적 확대\n② 수집 데이터에 대한 제3자 검증(인증기관 활용) 추진'
                    },
                    outstanding: {
                        answer: '예, 전체 공급망 대상 용수 사용량 데이터를 체계적으로 수집하고 제3자 검증을 통해 외부에 공시하고 있습니다.',
                        risk: '현행 수준 유지와 함께, 실시간 데이터 수집 시스템 고도화 및 협력사 데이터 품질 향상 지원 필요',
                        task: '[추가 개선 제안]\n① 협력사 수자원 데이터 관리 시스템 구축 지원\n② 공급망 수자원 데이터 품질 지표(KPI) 설정 및 모니터링 체계 도입'
                    }
                }
            },
            'W-14': {
                code: 'W-14',
                sub_code: 'TH1.14',
                topic: '성과 공시 및 투명성',
                category: '공급망 관리 및 공시',
                question: '수자원 활동 내용을 담은 보고서를 발간하거나 관련 정보를 정기적으로 업데이트하여 공개하고 있습니까?',
                cap: 7,
                levels: {
                    insufficient: {
                        answer: '아니오, 수자원 관련 성과를 외부에 공시하지 않습니다.',
                        risk: 'ESG 평가 기관으로부터 최하위 등급 부여 위험이 크며, 기관 투자자와 글로벌 고객사의 공급망 실사 요건 미충족으로 거래 손실 위험',
                        task: '① 내부 수자원 데이터 취합 및 GRI 303 공시 항목 대비 현황 점검\n② 당해 연도 지속가능경영보고서에 수자원 기초 데이터 최초 공시 추진'
                    },
                    average: {
                        answer: '예, 공시 채널을 통해 일부 수자원 관리 활동을 정성적으로 소개하고 있습니다.',
                        risk: '비표준 공시로 ESG 평가 기관의 데이터 활용도가 낮고, 기관투자자·고객의 정보 요구에 대응하기 어려움',
                        task: '① 현행 공시 내용과 GRI 303 항목 간 갭 분석\n② 다음 보고서부터 GRI 303 기준 준수 공시 계획 수립'
                    },
                    excellent: {
                        answer: '예, 글로벌 기준(GRI 303 또는 CDP Water)에 따라 수자원 관리 성과를 정기적으로 외부에 공시하고 있습니다.',
                        risk: '제3자 검증 미비로 공시 데이터의 신뢰성이 완전히 담보되지 않아 고신뢰 투자자 요구에 한계',
                        task: '① 수자원 공시 데이터 제3자 검증 도입 계획 수립\n② 이해관계자 피드백 수렴 채널 및 반영 절차 마련'
                    },
                    outstanding: {
                        answer: '예, 글로벌 기준(GRI 303 또는 CDP Water)을 준수하고 제3자 검증을 받은 수자원 성과를 공개하며, 이해관계자 피드백을 다음 연도 전략에 반영합니다.',
                        risk: '현행 수준 유지와 함께, ISSB IFRS S2 등 신규 공시 기준 대응 및 디지털 공시 플랫폼 활용 고도화 필요',
                        task: '[추가 개선 제안]\n① ISSB IFRS S2 적용 일정 및 내부 준비 계획 수립\n② 디지털 ESG 데이터 플랫폼을 통한 실시간 공시 고도화 검토'
                    }
                }
            }
        },
        categories: [
            {
                name: '정책 및 거버넌스',
                max: 23,
                recommend: 16.099999999999998
            },
            {
                name: '리스크 분석 및 평가',
                max: 14,
                recommend: 9.799999999999999
            },
            {
                name: '현황 측정 및 모니터링',
                max: 14,
                recommend: 9.799999999999999
            },
            {
                name: '대응 및 실행 전략',
                max: 28,
                recommend: 19.599999999999998
            },
            {
                name: '공급망 관리 및 공시',
                max: 21,
                recommend: 14.7
            }
        ]
    },
    biodiversity: {
        name: '생물다양성',
        order: [
            'BD-1',
            'BD-2',
            'BD-3',
            'BD-4',
            'BD-5',
            'BD-6',
            'BD-7',
            'BD-8',
            'BD-9',
            'BD-10',
            'BD-11',
            'BD-12',
            'BD-13'
        ],
        indicators: {
            'BD-1': {
                code: 'BD-1',
                sub_code: 'TH2.1',
                topic: '명문화된 생물다양성 정책',
                category: '정책 및 거버넌스',
                question: '생물다양성 보호 원칙을 담은 정책(독립 문서 또는 환경방침 내 조항)을 보유하고 있습니까?',
                cap: 8,
                levels: {
                    insufficient: {
                        answer: '아니오, 보유하고 있지 않습니다.',
                        risk: '규제 대응·고객 실사·ESG 평가 시 환경 거버넌스 부재로 즉각 감점 대상이 될 위험',
                        task: '① 환경경영방침에 생물다양성 보전 원칙 우선 반영\n② 독립 생물다양성 정책 수립 일정 로드맵 마련'
                    },
                    average: {
                        answer: '예, 환경경영방침 내 생물다양성 보호 및 관리 원칙을 명시하고 있습니다.',
                        risk: '독립 정책 부재로 생물다양성 리스크 대응이 느릴 수 있으며 고객·투자자 요구 수준 미달 위험',
                        task: '① 방침 내 생물다양성 조항 이행 현황 점검\n② 독립 정책 수립 필요성 및 우선순위 검토'
                    },
                    excellent: {
                        answer: '예, 독립적인 생물다양성 관리 정책을 보유하고 있습니다.',
                        risk: '정기 검토 체계 및 외부 공개 미비로 이해관계자 신뢰도 개선 여지 존재',
                        task: '① 정책의 경영진 승인 절차 공식화\n② 정기 검토 주기 및 외부 공개 채널 설정'
                    },
                    outstanding: {
                        answer: '예,  독립적인 생물다양성 관리 정책을 보유하고 있으며, 정기 검토 체계를 갖추고 경영진 승인, 외부 이해관계자가 접근 가능한 채널에 공개하고 있습니다.',
                        risk: '현행 수준 유지와 함께 정책 실효성과 현장 이행률을 지속 점검하여 형식적 관리에 그치지 않도록 유지 필요',
                        task: '[추가 개선 제안]\n① 생물다양성 정책 이행 현황 정기 감사 및 개선 사이클 운영\n② 이해관계자 피드백을 반영한 다음 연도 정책 갱신'
                    }
                }
            },
            'BD-2': {
                code: 'BD-2',
                sub_code: 'TH2.2',
                topic: '이사회 및 경영진 보고 체계',
                category: '정책 및 거버넌스',
                question: '생물다양성 관련 리스크/기회가 이사회·경영진에게 정기 보고되어 의사결정에 반영됩니까?',
                cap: 7,
                levels: {
                    insufficient: {
                        answer: '아니오, 이사회·경영진에 대한 생물다양성 보고 체계가 없습니다.',
                        risk: '중대 사고 발생 시 경영진이 적시에 인지·대응하지 못해 피해 확대 및 법적·재무적 책임 위험',
                        task: '① 생물다양성 주요 리스크 항목 목록화\n② 경영진 보고를 위한 최소한의 보고 양식 및 주기 설계'
                    },
                    average: {
                        answer: '예, 생물다양성 관리 활동 성과를 담당 임원에게 비정기적으로 보고하고 있습니다.',
                        risk: '보고 주기가 불규칙하여 사안 발생 시 경영진 대응이 지연될 수 있으며 의사결정 반영 여부를 추적하기 어려움',
                        task: '① 보고 주기 및 형식 표준화\n② 경영진 피드백 및 결정 사항 기록 체계 구축'
                    },
                    excellent: {
                        answer: '예, 생물다양성 리스크·기회를 경영진에게 정기적으로 보고하고 의사결정에 활용하고 있습니다.',
                        risk: '이사회 수준 보고 및 공개 체계가 미비하여 ESG 평가 항목 일부 미충족 가능성 존재',
                        task: '① 이사회·위원회 수준으로 보고 체계 격상 검토\n② 보고 이력 문서화 및 공개 가능 여부 검토'
                    },
                    outstanding: {
                        answer: '예, 이사회 또는 위원회에 생물다양성 리스크·기회가 정기 보고되며, 보고 이력과 결정 사항을 문서화하여 공개하고 있습니다.',
                        risk: '현행 체계를 유지하며 보고 내용의 품질·정확성 및 이해관계자와의 소통 실효성을 지속 점검 필요',
                        task: '[추가 개선 제안]\n① 이사회 보고 내용의 정량적 근거 강화\n② 이해관계자 공개 보고 항목 확대 및 국제 기준 연계'
                    }
                }
            },
            'BD-3': {
                code: 'BD-3',
                sub_code: 'TH2.3',
                topic: '조직 내재화 활동',
                category: '정책 및 거버넌스',
                question: '생물다양성을 주제로 임직원을 대상으로 한 정기적인 교육 또는 인식 제고 활동(캠페인 등)을 실시하고 있습니까?',
                cap: 7,
                levels: {
                    insufficient: {
                        answer: '아니오, 임직원을 대상으로 한 생물다양성 교육 또는 인식 제고 활동이 없습니다.',
                        risk: '현장 임직원이 생물다양성 훼손 행위를 인지하지 못해 의도치 않은 환경 피해 및 규제 위반 발생 가능성 존재',
                        task: '① 생물다양성 기초 개념 및 사내 환경 방침을 소개하는 최소 교육 콘텐츠 개발\n② 연 1회 이상 전사 대상 인식 제고 공지 또는 캠페인 실시 계획 수립'
                    },
                    average: {
                        answer: '예, 생물다양성 관련 내용을 일부 임직원에게 비정기적으로 안내하거나 공지한 적이 있습니다.',
                        risk: '교육 대상·내용·주기가 일관되지 않아 조직 전반의 인식 편차가 크고, 현장 실천으로 이어지기 어려운 구조적 한계 존재',
                        task: '① 교육 대상(전 임직원 또는 직무·부서별)과 교육 주기를 내부 규정으로 명문화\n② 생물다양성 보호 관련 현장 실천 가이드라인 제작 및 전사 배포'
                    },
                    excellent: {
                        answer: '예, 전사적으로 생물다양성 교육 또는 캠페인을 정기적으로 실시하고 있습니다.',
                        risk: '교육 실효성을 검증할 지표가 없어 현장 실천율이 낮을 수 있음',
                        task: '① 직무·부서별 교육 내용 차별화 및 현장 적용 중심 커리큘럼 강화\n② 교육 이수율, 사전·사후 인식 수준 등 정량적 성과 지표 도입 및 정기 모니터링'
                    },
                    outstanding: {
                        answer: '예, 전사적으로 생물다양성 교육 및 캠페인을 정기적으로 실시하고, 참여율 등을 관리하여 공개하고 있습니다.',
                        risk: '교육이 내부에 한정될 경우 공급망 전반의 인식 격차가 발생',
                        task: '[추가 개선 제안]\n① 교육 성과(이수율, 인식 향상도 등)를 생물다양성 보고서와 연계하여 공시 체계 고도화\n② 협력사·공급망 파트너 대상 교육 확대 및 공동 인식 제고 프로그램 운영 검토'
                    }
                }
            },
            'BD-4': {
                code: 'BD-4',
                sub_code: 'TH2.4',
                topic: '생물다양성 민감 지역 근접성 확인',
                category: '리스크 및 기회 평가',
                question: '사업장이나 주요 공급처가 법적 보호구역(국립공원 등) 안이나 인근에 위치해 있는지 파악하고 있습니까?',
                cap: 9,
                levels: {
                    insufficient: {
                        answer: '아니오, 보호구역 근접 여부를 확인하지 않았습니다.',
                        risk: '보호구역 인근 사업장에서 예고 없이 조업이 제한되거나 규제 대응 우선순위 설정 불가 위험',
                        task: '① UNEP-WCMC 또는 국내 환경부 보호지역 DB를 활용한 전 사업장 스크리닝\n② 고위험 사업장 우선 관리 목록 작성'
                    },
                    average: {
                        answer: '예, 일부 주요 사업장에 대해 보호구역 인접 여부를 비공식적으로 파악하고 있습니다.',
                        risk: '전 사업장 대상 체계적 분석 미비로 고위험 사업장 누락 가능성이 있으며 우선순위 기반 대응이 어려움',
                        task: '① 전 사업장 대상 공인 DB 스크리닝 적용\n② 결과를 바탕으로 고위험 사업장 우선 관리 목록 작성'
                    },
                    excellent: {
                        answer: '예, 전체 사업장에 대해 공인 DB를 활용하여 보호구역 근접성을 파악하고 내부 관리에 반영하고 있습니다.',
                        risk: '정기 업데이트 및 외부 공시 미비로 보호지역 변경에 따른 위험 변화를 반영하지 못할 위험',
                        task: '① 보호구역 근접성 분석 정기 갱신 주기 설정(연 1회 이상)\n② 분석 결과를 지속가능경영보고서에 수록 검토'
                    },
                    outstanding: {
                        answer: '예, 전체 사업장의 보호구역 근접성을 정기 업데이트하고 외부에 공시하며, 고위험 지역 대응 계획과 연동하고 있습니다.',
                        risk: '현행 수준을 유지하며 기후 변화 시나리오 반영 및 공급망 근접성까지 분석 확대 필요',
                        task: '[추가 개선 제안]\n① 공급망 주요 협력사 사업장까지 근접성 분석 확대\n② 지역 생태계 보전 기관과의 협력 프로그램 연계'
                    }
                }
            },
            'BD-5': {
                code: 'BD-5',
                sub_code: 'TH2.5',
                topic: '자연 자본 의존도 파악',
                category: '리스크 및 기회 평가',
                question: '사업 운영을 위해 자연 자본(물, 토지, 생물 소재 등)을 얼마나 사용하고 의존하는지 파악하고 있습니까?',
                cap: 8,
                levels: {
                    insufficient: {
                        answer: '아니오, 사업 운영의 자연 자본 의존도를 파악하고 있지 않습니다.',
                        risk: '자연 자본 공급 중단 리스크에 무방비이며 ESG 평가 시 리스크 관리 항목 감점 위험',
                        task: '① 주요 사업 활동별 자연 자본 사용 현황 목록화\n② TNFD LEAP 등 공인 도구 활용 초기 의존도 스크리닝 실시'
                    },
                    average: {
                        answer: '예, 주요 자연 자본(물, 토지 등)의 사용량은 파악하고 있으나 생물다양성 측면의 의존도 분석은 없습니다.',
                        risk: '생물 소재 등 비전통 자원의 의존도 누락으로 공급망 리스크 사각지대가 존재',
                        task: '① 생물 소재·생태계 서비스 항목으로 의존도 분석 범위 확대\n② 기존 데이터를 TNFD 의존도 분류 체계로 재정리'
                    },
                    excellent: {
                        answer: '예, 물·토지·생물 소재 등 주요 자연 자본별 의존도를 분석하고 내부 리스크 관리에 반영하고 있습니다.',
                        risk: '정량적 분석 및 외부 공시 미비로 투자자·고객의 리스크 관리 수준 검증 요구에 대응하기 어려움',
                        task: '① 의존도 정량화(발생 가능성·영향도) 시도\n② 분석 결과의 외부 보고서 수록 검토'
                    },
                    outstanding: {
                        answer: '예, 글로벌 공식 방법론(TNFD LEAP 등)으로 자연 자본 의존도를 정량화하고 외부에 공시하고 있습니다.',
                        risk: '분석 방법론과 결과의 신뢰성 유지를 위해 정기 업데이트 및 제3자 검증 체계 보완 필요',
                        task: '[추가 개선 제안]\n① 의존도 분석 결과의 정기 갱신 주기 및 담당자 지정\n② 외부 감사 또는 검증 프로세스 도입 검토'
                    }
                }
            },
            'BD-6': {
                code: 'BD-6',
                sub_code: 'TH2.6',
                topic: '공급망 생물다양성 진단',
                category: '공급망 및 이해관계자 참여',
                question: '협력사가 생물다양성 리스크를 관리하는지 점검하는 프로세스를 운영하고 있습니까?',
                cap: 7,
                levels: {
                    insufficient: {
                        answer: '아니오, 협력사의 생물다양성 리스크 관리 여부를 점검하는 프로세스가 없습니다.',
                        risk: '공급망 내 생물다양성 훼손 사례 발생 시 조기 감지가 불가하여, 규제 위반·공급 차질·평판 손상 등 복합적 리스크에 무방비로 노출될 위험',
                        task: '① 생물다양성에 영향을 미치는 주요 공급망 범위 및 산업군 파악\n② 생물다양성 리스크 점검을 위한 최소 기준 항목 목록화\n③ 공급업체 대상 기초 리스크 조사 양식 마련'
                    },
                    average: {
                        answer: '예, 일부 고위험 협력사에 한해 생물다양성 리스크를 비정기적으로 파악하고 있습니다.',
                        risk: '점검 범위와 주기의 임의성으로 인해 고위험 공급업체가 누락될 가능성이 있으며, 일관성 있는 리스크 대응이 어려워 사각지대가 발생할 위험.',
                        task: '① 생물다양성 리스크 점검 대상 공급업체 선정 기준 수립\n② 점검 주기 및 방법의 표준화\n③ 비정기 점검 결과의 기록·관리 체계 마련'
                    },
                    excellent: {
                        answer: '예, 주요 협력사를 대상으로 생물다양성 리스크 점검 항목을 마련하여 정기적으로 평가하고 있습니다.',
                        risk: '점검 결과가 계약·거래 지속 여부 등 실질적 의사결정과 연계되지 않아 리스크 저감 실효성이 제한되고, 공급업체 개선 유인이 부족할 위험.',
                        task: '① 생물다양성 리스크 평가 결과의 공급업체 등급화 및 관리 연계 방안 수립\n② 고위험 공급업체 대상 개선 계획 제출 요구 및 이행 모니터링 체계 구축\n③ 점검 결과의 내부 보고 및 경영 의사결정 활용 프로세스 강화'
                    },
                    outstanding: {
                        answer: '예, 전체 협력사를 대상으로 생물다양성 리스크 평가 체계를 구축하고, 평가 결과를 공급업체 선정·관리 의사결정에 반영하며 외부에 공개하고 있습니다.',
                        risk: '신규 공급업체 편입, 생산지 변동 등 공급망 구조 변화 시 기존 평가 결과의 유효성이 저하되어 리스크 재평가가 누락될 위험.',
                        task: '[추가 개선 제안]\n① 공급망 변동 발생 시 생물다양성 리스크 재평가 절차 제도화\n② TNFD 등 국제 기준 변화에 맞춘 점검 항목 주기적 업데이트\n③ 공급망 생물다양성 성과 개선을 유도하는 인센티브·패널티 제도 도입 검토'
                    }
                }
            },
            'BD-7': {
                code: 'BD-7',
                sub_code: 'TH2.7',
                topic: '위험 원자재 공급망 관리',
                category: '공급망 및 이해관계자 참여',
                question: '원재료를 구매할 때 숲을 파괴하거나 자연을 심하게 훼손하여 생산된 제품인지 확인하는 기준이 있습니까?',
                cap: 8,
                levels: {
                    insufficient: {
                        answer: '아니오, 주요 원자재의 환경 연계성을 확인하는 기준이 없습니다.',
                        risk: 'EU EUDR 등 규제 대상 원자재 사용 시 수출 제한·공급 중단 리스크 및 브랜드 평판 손상 위험',
                        task: '① 현재 조달 원자재 중 고위험 품목(팜유, 목재, 대두, 쇠고기 등) 목록화\n② EU EUDR 등 주요 규제 적용 여부 확인'
                    },
                    average: {
                        answer: '예, 주요 원자재에 대해 환경 인증 여부를 비공식적으로 확인하고 있습니다.',
                        risk: '비공식 확인으로 데이터 신뢰도가 낮으며 EU EUDR 등 공급망 실사 의무 대응에 한계',
                        task: '① 주요 원자재별 환경 기준 및 인증 요건 공식화\n② 공급업체 계약서에 생물다양성 관련 준수 사항 명시'
                    },
                    excellent: {
                        answer: '예, 주요 원자재에 대해 삼림 벌채·생물다양성 훼손 연계 여부를 확인하는 공식 기준을 보유하고 있습니다.',
                        risk: '2차 이하 공급망까지 기준이 적용되지 않아 사각지대가 존재할 수 있음',
                        task: '① 2차 이하 공급업체까지 기준 확대 적용 로드맵 수립\n② 공급망 위험 원자재 관리 현황 외부 공시'
                    },
                    outstanding: {
                        answer: '예, 전 공급망 대상 위험 원자재 기준을 적용하고 정기 이행 점검 결과를 외부에 공시합니다.',
                        risk: '현행 수준 유지와 함께 공급업체 역량 강화 지원 및 인증 취득 지원 프로그램 고도화 필요',
                        task: '[추가 개선 제안]\n① 공급업체 생물다양성 역량 강화 교육·지원 프로그램 운영\n② 공급망 생물다양성 관리 현황 지속가능경영보고서 수록'
                    }
                }
            },
            'BD-8': {
                code: 'BD-8',
                sub_code: 'TH2.8',
                topic: '지역사회 협력 및 의견 수렴',
                category: '공급망 및 이해관계자 참여',
                question: '생물다양성 보전 활동을 할 때 지역사회와 소통하고 의견을 듣는 절차가 있습니까?',
                cap: 7,
                levels: {
                    insufficient: {
                        answer: '아니오, 지역사회와 소통하는 절차가 없습니다.',
                        risk: '지역사회 반발로 인한 사업 지연 및 갈등 발생 위험, CBD·ESRS 요건 미충족',
                        task: '① 주요 사업장 인근 지역사회 이해관계자 목록 작성\n② 정기 소통 채널 최소 1개 이상 설치'
                    },
                    average: {
                        answer: '예, 지역사회와의 소통 채널을 활용하여 생물다양성 관련 활동을 비정기적으로 안내하고 있습니다.',
                        risk: '일방적 안내만으로는 지역사회 신뢰 확보가 어려우며 갈등 예방 효과가 낮음',
                        task: '① 사전 의견 수렴 절차(주민 설명회 등) 도입\n② 지역사회 의견을 활동 계획에 반영하는 피드백 체계 수립'
                    },
                    excellent: {
                        answer: '예, 생물다양성 활동 계획 시 지역사회와 사전 협의하고 의견을 반영하는 절차를 운영합니다.',
                        risk: '원주민 등 취약 집단에 대한 FPIC 원칙 적용과 결과 공개가 미비할 수 있음',
                        task: '① FPIC 원칙 적용 범위 및 절차 공식화\n② 협력 결과를 외부 보고서에 수록'
                    },
                    outstanding: {
                        answer: '예, 자유로운 사전 고지된 동의(FPIC) 원칙을 포함한 지역사회 협력 절차를 운영하고, 협력 결과와 반영 사항을 외부에 공시합니다.',
                        risk: '현행 수준 유지와 함께 지역사회와의 공동 생물다양성 보전 프로젝트 심화 고도화 필요',
                        task: '[추가 개선 제안]\n① 지역사회와의 공동 생태 모니터링 프로그램 운영\n② 협력 성과 지속가능경영보고서 수록'
                    }
                }
            },
            'BD-9': {
                code: 'BD-9',
                sub_code: 'TH2.9',
                topic: '사업장 내 생태 거점 및 인프라 관리',
                category: '서식지 및 생태계 보전',
                question: '가동 중인 사업장 부지 내(On-site)에 생물종 보호를 위한 친환경 활동 및 인프라 구축을 하고 있습니까?',
                cap: 8,
                levels: {
                    insufficient: {
                        answer: '아니오, 사업장 내 생물종 보호를 위한 친환경 인프라와 활동이 없습니다.',
                        risk: '사업장이 생태계 단절의 원인이 될 수 있으며 지역 생물다양성 악화에 기여할 위험',
                        task: '① 사업장 내 자생종 식물 식재 가능 면적 파악\n② 소규모 친환경 녹지 조성 시범 추진'
                    },
                    average: {
                        answer: '예, 일부 구역에 친환경 인프라를 구축 중이나 생태 기능 중심의 체계적 관리는 하고 있지 않습니다.',
                        risk: '외래종 위주 조경은 오히려 생태계를 교란할 수 있으며 생물다양성 기여 효과가 낮음',
                        task: '① 현재 식재 종목의 자생종 비율 파악 및 개선 계획 수립\n② 생태 통로 또는 완충 녹지대 조성 가능 구역 검토\n③ 친화 관리 활동 성과(자생종 비율, 서식 종 수 등) 정기 측정 체계 도입'
                    },
                    excellent: {
                        answer: '예, 생태 통로 조성,자생 식물 식재 등 체계적인 사업장 내 생물다양성 친화 관리를 실천하고 성과 관리를 하고 있습니다.',
                        risk: '외부 공시가 미비하여 이해관계자 신뢰도 제고에 한계',
                        task: '① 활동 내용 외부 보고서 수록'
                    },
                    outstanding: {
                        answer: '예, 외부 전문 생태기관과 함께 사업장 내 생물다양성 현황을 정기 모니터링하고, 그 결과를 외부에 공시하고 있습니다.',
                        risk: '현행 수준 유지와 함께 인근 사업장 간 생태 통로 연결 및 지역 생태망 연계 고도화 필요',
                        task: '[추가 개선 제안]\n① 인근 지역 생태 통로와의 연계 가능성 조사\n② 사업장 생물다양성 현황 지역 사회와 정기 공유'
                    }
                }
            },
            'BD-10': {
                code: 'BD-10',
                sub_code: 'TH2.10',
                topic: '외부 서식지 복원 및 상쇄(Offset)',
                category: '서식지 및 생태계 보전',
                question: '사업 운영으로 인해 영향(훼손)을 받은 인근 지역이나 외부 서식지에 대해 복구 및 손실 상쇄(Offset) 프로그램을 운영하고 있습니까?',
                cap: 8,
                levels: {
                    insufficient: {
                        answer: '아니오, 외부 서식지 복원 프로그램을 운영하지 않습니다.',
                        risk: '생태계 서비스 손실이 누적되고 규제 강화 시 복원 의무 불이행에 따른 법적·재무적 제재 위험',
                        task: '① 사업장별 훼손 현황 및 복원 필요 면적 파악\n② 소규모 시범 복원 프로그램 착수'
                    },
                    average: {
                        answer: '예, 사업장 인근 대상의 단순 관리 및 보호 활동은 하고 있으나 전문적인 생태계 서식지 복원 프로그램은 없습니다.',
                        risk: '단순 보호 활동만으로는 생태 기능 회복이 불충분하며 GRI·ESRS 요건을 완전히 충족하지 못함',
                        task: '① 자생종 위주의 식재·복원 방식으로 전환\n② 복원 면적 및 종 다양성 회복 성과 측정 체계 도입'
                    },
                    excellent: {
                        answer: '예, 침입 외래종의 자생종 대체, 생물 서식지 조성 등 체계적인 복원 프로그램을 운영하고 있습니다.',
                        risk: '외부 공시 및 제3자 생태 모니터링이 미비하여 복원 효과의 검증이 어려움',
                        task: '① 복원 프로그램 성과를 외부 보고서에 수록\n② 전문 생태 기관과의 협력을 통한 독립 모니터링 체계 구축'
                    },
                    outstanding: {
                        answer: '예, 외부 전문기관과 협력하여 \'No Net Loss\' 혹은 \'Net Positive\' 원칙에 따라 손실 상쇄(Offset) 프로그램을 운영하고, 그 성과를 외부 공시하고 있습니다.',
                        risk: '현행 수준 유지와 함께 공급망 협력사까지 복원 기준 동일 적용 확대 필요',
                        task: '[추가 개선 제안]\n① 생물다양성 상쇄(offset) 기준 연계 가능성 검토\n② 복원 성과 지역사회 공유 프로그램 운영'
                    }
                }
            },
            'BD-11': {
                code: 'BD-11',
                sub_code: 'TH2.11',
                topic: '생물다양성 정량 목표 수립',
                category: '목표 설정 및 성과 관리',
                question: '생물다양성 손실을 줄이기 위해 기한이 명시된(Time-bound) 구체적 목표를 보유하고 있습니까?',
                cap: 8,
                levels: {
                    insufficient: {
                        answer: '아니오, 생물다양성 관련 정량적 목표가 없습니다.',
                        risk: '성과 측정·개선 방향 부재로 생물다양성 손실이 지속되고 ESG 평가 최하위 등급 위험',
                        task: '① 현재 사업장별 생태 현황 베이스라인 데이터 확보\n② 단기(1년) 우선 목표 수치 설정 착수'
                    },
                    average: {
                        answer: '예, 내부 관리용 생물다양성 목표(기한 미명시)를 보유하고 있습니다.',
                        risk: '기한 미명시 목표는 ESG 평가에서 낮은 점수를 받으며 실질적 감축 성과로 이어지지 않을 위험',
                        task: '① 기존 목표에 달성 기한 및 베이스라인 수치 추가\n② 연간 진척 현황 관리 체계 수립'
                    },
                    excellent: {
                        answer: '예, 구체적인 기한(단·중·장기)이 명시된 생물다양성 목표를 수립하고 진척을 관리하고 있습니다.',
                        risk: '과학 기반 목표(SBTN)와의 연계 및 외부 공시가 이루어지지 않아 글로벌 ESG 평가 상위권 진입에 한계',
                        task: '① SBTN 등 국제 기준 연계 가능성 검토\n② 목표 및 달성 현황 외부 공시 계획 수립'
                    },
                    outstanding: {
                        answer: '예, 글로벌 표준(SBTN 또는 GBF 등)에 연계된 기한 명시 목표를 수립하고 외부에 공시하고 있습니다.',
                        risk: '현 수준 유지와 함께 목표 달성 여부의 제3자 검증 및 미달 시 수정 계획 수립 프로세스 보완 필요',
                        task: '[추가 개선 제안]\n① 목표 달성 현황 제3자 검증 도입 검토\n② 미달 시 원인 분석 및 목표 재설정 프로세스 공식화'
                    }
                }
            },
            'BD-12': {
                code: 'BD-12',
                sub_code: 'TH2.12',
                topic: '생물다양성 성과 지표 관리',
                category: '목표 설정 및 성과 관리',
                question: '목표 달성 여부를 확인하기 위해 성과 측정이 가능한 구체적인 수치 데이터(KPI)를 관리 중입니까?',
                cap: 7,
                levels: {
                    insufficient: {
                        answer: '아니오, 측정 가능한 지표를 관리하고 있지 않습니다.',
                        risk: '목표 달성 여부 판단 불가 및 ESG 공시 요건 미충족으로 평가 감점 위험',
                        task: '① 사업 특성에 맞는 생물다양성 지표 후보 목록 작성\n② 측정 가능한 1~2개 우선 지표 선정 및 데이터 수집 착수'
                    },
                    average: {
                        answer: '예, 일부 정성적 활동은 기록하고 있으나 정량적 성과 지표 체계가 없습니다.',
                        risk: '정성적 기록만으로는 ESG 평가 및 이해관계자 요구를 충족하기 어려우며 재현성이 낮음',
                        task: '① 기존 활동 기록을 정량 지표(면적, 개체수 등)로 전환\n② 연간 집계 및 목표 대비 달성률 관리 체계 수립'
                    },
                    excellent: {
                        answer: '예, 보호종 수, 나무 식재 수 등 정량 지표를 설정하고 연간 달성 현황을 추적·관리하고 있습니다.',
                        risk: '외부 공시 및 제3자 검증이 이루어지지 않아 이해관계자 신뢰도 제고에 한계',
                        task: '① 성과 지표를 외부 보고서에 수록\n② 제3자 검증 도입 가능성 검토'
                    },
                    outstanding: {
                        answer: '예, 정량 지표를 설정하고 연간 달성 현황을 추적하며, 외부에 공시하고 제3자 검증을 받고 있습니다.',
                        risk: '현행 수준 유지와 함께 지표의 국제 표준 정렬 및 업종별 벤치마킹 고도화 필요',
                        task: '[추가 개선 제안]\n① TNFD 권장 지표 체계와의 정렬 수준 점검\n② 업종 동종사 대비 성과 벤치마킹 실시'
                    }
                }
            },
            'BD-13': {
                code: 'BD-13',
                sub_code: 'TH2.13',
                topic: '성과 공시 및 투명성',
                category: '모니터링 및 공시',
                question: '생물다양성 활동 내용을 담은 보고서를 발간하거나 관련 정보를 정기적으로 업데이트하여 공개하고 있습니까?',
                cap: 8,
                levels: {
                    insufficient: {
                        answer: '아니오, 생물다양성 관련 정보를 외부에 공시하지 않습니다.',
                        risk: 'ESG 평가 기관으로부터 최하위 등급 부여 위험이 크며 기관 투자자와 글로벌 고객의 공급망 실사 요건 미충족',
                        task: '① 내부 생물다양성 데이터 취합 및 GRI 101 공시 항목 대비 현황 점검\n② 당해 연도 지속가능경영보고서에 생물다양성 기초 데이터 최초 공시 추진'
                    },
                    average: {
                        answer: '예, 공시 채널을 통해 일부 생물다양성 활동을 정성적으로 소개하고 있습니다.',
                        risk: '비표준 공시로 ESG 평가 기관의 데이터 활용도가 낮고 기관투자자·고객의 정보 요구에 대응하기 어려움',
                        task: '① 현행 공시 내용과 GRI 101 항목 간 갭 분석\n② 다음 보고서부터 GRI 101 기준 준수 공시 계획 수립'
                    },
                    excellent: {
                        answer: '예, 글로벌 기준(GRI 101 또는 TNFD)에 따라 생물다양성 성과를 정기적으로 외부에 공시하고 있습니다.',
                        risk: '제3자 검증 미비로 공시 데이터의 신뢰성이 완전히 담보되지 않아 고신뢰 투자자 요구에 한계',
                        task: '① 생물다양성 공시 데이터 제3자 검증 도입 계획 수립\n② 이해관계자 피드백 수렴 채널 및 반영 절차 마련'
                    },
                    outstanding: {
                        answer: '예, 글로벌 기준(GRI 101 또는 TNFD)을 준수하고 제3자 검증을 받은 생물다양성 성과를 공개하며, 피드백을 다음 연도 전략에 반영합니다.',
                        risk: '현행 수준 유지와 함께 ESRS E4 등 신규 공시 기준 대응 및 디지털 공시 플랫폼 활용 고도화 필요',
                        task: '[추가 개선 제안]\n① ESRS E4 적용 일정 및 내부 준비 계획 수립\n② 디지털 ESG 데이터 플랫폼을 통한 실시간 공시 고도화 검토'
                    }
                }
            }
        },
        categories: [
            {
                name: '정책 및 거버넌스',
                max: 22,
                recommend: 15.399999999999999
            },
            {
                name: '리스크 및 기회 평가',
                max: 17,
                recommend: 11.899999999999999
            },
            {
                name: '공급망 및 이해관계자 참여',
                max: 22,
                recommend: 15.399999999999999
            },
            {
                name: '서식지 및 생태계 보전',
                max: 16,
                recommend: 11.2
            },
            {
                name: '목표 설정 및 성과 관리',
                max: 8,
                recommend: 5.6
            },
            {
                name: '모니터링 및 공시',
                max: 8,
                recommend: 5.6
            }
        ]
    }
};

export const levelMeta = {
    insufficient: [
        '관리 체계 미비',
        '리스크 관리 체계가 구축되지 않아 실제적·잠재적 위협에 노출된 상태'
    ],
    average: [
        '기초 관리 이행',
        '최소한의 필수 대응 규정만을 준수하며 현상을 유지 중인 상태'
    ],
    excellent: [
        '자율 경영 확립',
        '자체적인 리스크 관리 시스템을 통해 선순환 구조를 확립한 상태'
    ],
    outstanding: [
        '전략적 고도화',
        '외부 검증 및 투자를 포함한 글로벌 스탠다드 수준의 확장 경영 상태'
    ],
    na: [
        '',
        ''
    ]
};

export const appendixUrls = [
    {
        group: '글로벌 프레임워크 / 공시 기준',
        col: '도구·기관',
        rows: [
            [
                'CDP Water 프로그램',
                'https://www.cdp.net/en/water'
            ],
            [
                'CDP 질문서 가이드',
                'https://www.cdp.net/en/guidance/guidance-for-companies'
            ],
            [
                'GRI Standards 다운로드',
                'https://www.globalreporting.org/how-to-use-the-gri-standards/resource-center/'
            ],
            [
                'TCFD 거버넌스 권고안',
                'https://www.fsb-tcfd.org/wp-content/uploads/2017/06/FINAL-2017-TCFD-Report-11052018.pdf'
            ],
            [
                'UN CEO Water Mandate',
                'https://ceowatermandate.org/'
            ],
            [
                'TNFD v1.0 권고안',
                'https://tnfd.global/wp-content/uploads/2023/10/FINAL-18-09-23-TNFD-final-recommendations-release-1.pdf'
            ],
            [
                '쿤밍-몬트리올 GBF Target 15',
                'https://www.cbd.int/gbf/targets/15'
            ],
            [
                '쿤밍-몬트리올 GBF 23개 목표',
                'https://www.cbd.int/gbf'
            ],
            [
                'GBF Target 22 (지역사회 참여)',
                'https://www.cbd.int/gbf/targets/22'
            ],
            [
                'CBD 비즈니스 행동 플랫폼',
                'https://www.cbd.int/business'
            ],
            [
                'SBTN 단계별 가이드',
                'https://sciencebasedtargetsnetwork.org/how-it-works/step-by-step-guidance/'
            ],
            [
                'EU EUDR 전문 (EUR-Lex)',
                'https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:32023R1115'
            ],
            [
                'IUCN 생물다양성',
                'https://iucn.org/our-work/biodiversity'
            ],
            [
                'IUCN 적색목록',
                'https://www.iucnredlist.org'
            ],
            [
                'IUCN 침입외래종 DB',
                'https://www.iucngisd.org/gisd/'
            ]
        ]
    },
    {
        group: '글로벌 리스크 분석 / 데이터 도구',
        col: '도구·기관',
        rows: [
            [
                'WRI Aqueduct (물 스트레스 지도)',
                'https://www.wri.org/applications/aqueduct/water-risk-atlas/'
            ],
            [
                'ENCORE (자연 의존도 탐색)',
                'https://www.encorenature.org/en'
            ],
            [
                'IBAT (통합 생물다양성 평가, 유료)',
                'https://www.ibat-alliance.org'
            ],
            [
                'WDPA (세계보호지역 DB)',
                'https://www.protectedplanet.net/en/thematic-areas/wdpa'
            ],
            [
                'Global Forest Watch (삼림 변화 모니터링)',
                'https://www.globalforestwatch.org/map/'
            ]
        ]
    },
    {
        group: '한국 유관 정부·공공기관',
        col: '기관',
        rows: [
            [
                '환경부 물환경정보시스템',
                'https://water.nier.go.kr'
            ],
            [
                '환경부 하수도 정보시스템',
                'https://www.hasudoinfo.or.kr'
            ],
            [
                '국가수자원관리종합정보시스템 (WAMIS)',
                'https://www.wamis.go.kr'
            ],
            [
                '한국수자원공사 지하수 정보시스템',
                'https://www.gims.go.kr'
            ],
            [
                '국가기후위기적응센터',
                'https://kaccc.kei.re.kr/'
            ],
            [
                '기상청 기후정보 포털',
                'https://www.climate.go.kr/home/'
            ],
            [
                '환경부 국토환경성평가지도',
                'https://ecvam.neins.go.kr'
            ],
            [
                '환경부 생물다양성 정보공유체계',
                'https://www.kbr.go.kr'
            ],
            [
                '국립생태원 (멸종위기 야생생물)',
                'https://www.nie.re.kr/nie/pgm/edDistStat/list.do?menuNo=200128'
            ],
            [
                '국립생태원 메인',
                'https://www.nie.re.kr/nie/main/main.do'
            ]
        ]
    }
];

export const riskSummary = {
    overall: {
        level: 'HIGH',
        desc: '용수 공급 안정성 및 생태계 영향 측면에서 중대한 리스크가 식별되었으며, 전사 차원의 즉각적인 대응책 마련과 관리 체계 구축이 시급합니다.'
    },
    note: '※ 기업 응답 데이터를 바탕으로 도출된 상대적 리스크 수준입니다.',
    water: [
        {
            label: '위치',
            level: 'Low',
            desc: '별도 분석 예정'
        },
        {
            label: '공정',
            level: 'Medium',
            desc: '공정별 수자원 관리 필요'
        },
        {
            label: '설비',
            level: 'Low',
            desc: '수자원 소비·유출 리스크 낮음'
        },
        {
            label: '폐수배출',
            level: 'High',
            desc: '처리 불량 시 직접 환경오염 책임 및 규제 리스크 높음'
        },
        {
            label: '오염물질',
            level: 'Low',
            desc: '수질오염 영향 범위 제한적'
        }
    ],
    biodiversity: [
        {
            label: '위치',
            level: 'Low',
            desc: '별도 분석 예정'
        },
        {
            label: '사업장 인프라',
            level: 'Medium',
            desc: '부지 내 생태계 완충 조치 검토 필요'
        },
        {
            label: '공정',
            level: 'High',
            desc: '인근 생태계 복합 교란 리스크 높음'
        },
        {
            label: '원자재',
            level: 'Medium',
            desc: '원자재 조달 경로별 환경 실사 필요'
        },
        {
            label: '토지 이용',
            level: 'Low',
            desc: '신규 생태계 훼손 가능성 낮음'
        }
    ]
};

export default { rubric, levelMeta, appendixUrls, riskSummary };
